"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AccordionHeader", {
  enumerable: true,
  get: function get() {
    return _AccordionHeader["default"];
  }
});
Object.defineProperty(exports, "AccordionBody", {
  enumerable: true,
  get: function get() {
    return _AccordionBody["default"];
  }
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _AccordionHeader = _interopRequireDefault(require("./AccordionHeader"));
var _AccordionBody = _interopRequireDefault(require("./AccordionBody"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;
  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/**
 * Collapsable content with a visible header
 */
var Accordion = function Accordion(_ref) {
  var startOpen = _ref.startOpen,
    children = _ref.children,
    onClick = _ref.onClick,
    rest = _objectWithoutProperties(_ref, ["startOpen", "children", "onClick"]);
  var _useState = (0, _react.useState)(startOpen),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var toggle = function toggle() {
    var newState = !isOpen;
    setIsOpen(newState);
    if (onClick) {
      onClick(newState);
    }
  };
  return _react["default"].createElement("div", rest, _react["default"].Children.map(children, function (child) {
    if (!child || !child.type) return null;
    if (child.type.displayName === "Header") {
      return _react["default"].cloneElement(child, {
        onClick: toggle,
        isOpen: isOpen
      });
    }
    if (child.type.displayName === "Body") {
      return _react["default"].cloneElement(child, {
        isOpen: isOpen
      });
    }
  }));
};
Accordion.defaultProps = {
  startOpen: false,
  onClick: null
};
Accordion.propTypes = {
  /** Should the accordion start open */
  startOpen: _propTypes["default"].bool,
  /** Any Children to display in body of accordion */
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired,
  /** onclick function to be passed to accordion */
  onClick: _propTypes["default"].func
};
Accordion.Header = _AccordionHeader["default"];
Accordion.Body = _AccordionBody["default"];
var _default = Accordion;
exports["default"] = _default;